<ng-content select="[appTablePrefix]"></ng-content>

<ng-template #toolbarFormField><ng-content select="mat-form-field"></ng-content></ng-template>
<ng-template #toolbarControls><ng-content select="[appTableToolbar]"></ng-content></ng-template>

<ng-template #toolbarButtons>
    <button type="button" *ngIf="!(mobileMode$ | async) && columnMap?.length > 0"
            mat-fab extended [disableRipple]="true" color="accent"
            [extended]="!(desktopMode$ | async)"
            [disabled]="isLoadingInitialResults"
            [matMenuTriggerFor]="columnsSelectorMenu">
        <mat-icon [svgIcon]="'v2:fi-br-column'"></mat-icon>
        <ng-container *ngIf="!(desktopMode$ | async)">{{ 'Columns' }}</ng-container>
    </button>
    <mat-menu #columnsSelectorMenu="matMenu" xPosition="before" class="v2-panel" [overlapTrigger]="false"
              (closed)="persistColumns()">
        <ng-template [ngForOf]="availableColumns" let-column ngFor>
            <div *ngIf="!column.hasOwnProperty('isMobile') || (column.isMobile && (mobileMode$ | async))"
                 [disableRipple]="true" mat-menu-item>
                <mat-checkbox [checked]="selectedColumns.isSelected(column)"
                              (change)="selectedColumns.toggle(column); storeColumns()"
                              (click)="$event.stopPropagation()">
                    <span class="select-column-label">{{ column.title }}</span>
                </mat-checkbox>
            </div>
        </ng-template>

        <mat-divider class="my-2"></mat-divider>

        <button type="button" (click)="resetColumns()" mat-menu-item>{{ 'Reset Columns' }}</button>
    </mat-menu>

    <button type="button" *ngIf="hasFilters"
            mat-fab [disableRipple]="true" color="accent"
            [extended]="!(desktopMode$ | async)"
            [disabled]="isLoadingInitialResults"
            (click)="showFilters.next(filters)">
        <mat-icon [svgIcon]="'v2:fi-br-filter'"></mat-icon>
        <ng-container *ngIf="!(desktopMode$ | async)">{{ 'Filters' }}{{ filterCount > 0 ? ' (' + filterCount + ')' : '' }}</ng-container>
    </button>

    <ng-container *ngIf="tableActions">
        <button type="button" mat-fab [disableRipple]="true" color="accent"
                class="actions-button"
                [extended]="!(tabletMode$ | async)"
                [matMenuTriggerFor]="actionsMenu">
            <ng-container *ngIf="!(tabletMode$ | async)">{{ actionsMenuLabel() }}</ng-container>
            <mat-icon iconPositionEnd>expand_more</mat-icon>
        </button>
        <mat-menu #actionsMenu="matMenu" xPosition="before" class="v2-panel" [overlapTrigger]="false">
            <ng-container [ngTemplateOutlet]="tableActions.templateRef"></ng-container>
        </mat-menu>
    </ng-container>
</ng-template>

<mat-card>
    <ng-content select="mat-card-header"></ng-content>

    <mat-divider *ngIf="cardHeader"></mat-divider>

    <mat-card-content>
        <ng-content select="[appTableMap]"></ng-content>

        <ng-content select="app-widget-group"></ng-content>

        <ng-container *ngIf="!initialEmptyState">
            <ng-template #stackedToolbar>
                <mat-toolbar class="app-table-toolbar" animated>
                    <mat-toolbar-row>
                        <mat-form-field appearance="outline" subscriptSizing="dynamic">
                            <mat-icon [svgIcon]="'v2:fi-br-search'" matIconPrefix></mat-icon>
                            <input type="text"
                                   matInput
                                   [placeholder]="searchPlaceholder"
                                   [attr.aria-label]="'Search'"
                                   (keydown.enter)="$event.preventDefault()"
                                   [formControl]="searchControl">
                        </mat-form-field>

                        <ng-container *ngTemplateOutlet="toolbarControls"></ng-container>
                        <ng-container *ngTemplateOutlet="toolbarButtons"></ng-container>
                    </mat-toolbar-row>

                    <mat-toolbar-row *ngIf="!!formFieldRef">
                        <ng-container *ngTemplateOutlet="toolbarFormField"></ng-container>
                    </mat-toolbar-row>

                    <mat-progress-bar mode="query" color="primary" [class.active]="!isLoadingInitialResults && isLoadingResults">
                    </mat-progress-bar>
                </mat-toolbar>
            </ng-template>

            <mat-toolbar *ngIf="!(tabletMode$ | async) && !(mobileMode$ | async); else stackedToolbar" class="app-table-toolbar" animated>
                <button-group>
                    <mat-form-field appearance="outline" subscriptSizing="dynamic">
                        <mat-icon [svgIcon]="'v2:fi-br-search'" matIconPrefix></mat-icon>
                        <input type="text"
                               matInput
                               [placeholder]="searchPlaceholder"
                               [attr.aria-label]="'Search'"
                               (keydown.enter)="$event.preventDefault()"
                               [formControl]="searchControl">
                    </mat-form-field>

                    <ng-container *ngIf="!!formFieldRef">
                        <ng-container *ngTemplateOutlet="toolbarFormField"></ng-container>
                    </ng-container>
                </button-group>

                <flex-spacer></flex-spacer>

                <button-group>
                    <ng-container *ngTemplateOutlet="toolbarControls"></ng-container>
                    <ng-container *ngTemplateOutlet="toolbarButtons"></ng-container>
                </button-group>

                <mat-progress-bar mode="query" color="primary" [class.active]="!isLoadingInitialResults && isLoadingResults">
                </mat-progress-bar>
            </mat-toolbar>
        </ng-container>

        <section class="app-table-container" [class.initial-loading]="isLoadingInitialResults" animated>
            <mat-table [dataSource]="data"
                       [class.mobile-layout]="mobileMode$ | async"
                       [class.multiple-data-rows]="hasExpandableRows"
                       appTable multiTemplateDataRows
                       [compact]="compact"
                       [tableCheckboxColumnDef]="columnMap"
                       [tableCheckboxEnabled]="hasCheckboxSelection"
                       [tableCheckboxRowDisabled]="checkboxRowDisabledFn"
                       [tableData]="data"
                       [tableInitialLoad]="isLoadingInitialResults"
                       (tableCheckboxRowChange)="selection = $event; checkboxSelection.emit(selection)">
                <ng-content></ng-content>

                <div *matNoDataRow>
                    <ng-template #emptyState>
                        <ng-template #emptyStateContent>
                            <app-empty-state [searchTerm]="searchControl.value">
                                <span emptyStateTitle>{{ 'No results to display' }}</span>
                            </app-empty-state>
                        </ng-template>

                        <ng-container *ngIf="emptyStateRef; else emptyStateContent">
                            <ng-content select="app-empty-state"></ng-content>
                        </ng-container>
                    </ng-template>

                    <ng-container *ngIf="isLoadingInitialResults || isLoadingResults; else emptyState">
                        <app-loading-table-state
                            [keys]="displayedColumnKeys$ | async"
                            [headerRow]="tableHeaderRef">
                        </app-loading-table-state>
                    </ng-container>
                </div>

                <!-- Expanded row content column (spans full width) -->
                <ng-container *ngIf="hasExpandableRows" matColumnDef="expandedRowContent">
                    <mat-cell *matCellDef="let row">
                        <div class="expanded-content" *ngIf="isRowExpanded(row)">
                            <ng-container *ngTemplateOutlet="expandedRowTemplate.templateRef; context: { $implicit: row }">
                            </ng-container>
                        </div>
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="arrowRight">
                    <mat-header-cell *matHeaderCellDef>&nbsp;</mat-header-cell>
                    <mat-cell *matCellDef="let row">
                        <mat-spinner *ngIf="loadingRow$[row.id] | async" [diameter]="15" [strokeWidth]="2"></mat-spinner>
                        <mat-icon *ngIf="!(loadingRow$[row.id] | async)" class="highlight-on-hover" [svgIcon]="'v2:fi-br-next'"></mat-icon>
                    </mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="displayedColumnKeys$ | async; sticky: true"
                                [headerRow]="true"
                                appTableRow>
                </mat-header-row>

                <mat-row *matRowDef="let row; columns: displayedColumnKeys$ | async"
                         [class.primary-row]="hasExpandableRows"
                         [class.group-divider]="rowGroupDividerFn ? rowGroupDividerFn(row) : false"
                         [class.expanded]="hasExpandableRows && isRowExpanded(row)"
                         [hasAnimation]="rowsAnimated"
                         [selectableRow]="rowSelectable"
                         [deletedRow]="showDeletedRowStyle && !!row?.deletedAt"
                         [warningRow]="rowWarningFn ? rowWarningFn(row) : false"
                         [disabledRow]="rowDisabledFn ? rowDisabledFn(row) : false"
                         (click)="selectRow(row)"
                         appTableRow
                         animated
                         fadeFrom="bottom"
                         delayed="table">
                </mat-row>

                <!-- Secondary row for expanded content -->
                <ng-container *ngIf="hasExpandableRows">
                    <mat-row *matRowDef="let row; columns: ['expandedRowContent'];"
                             class="secondary-row"
                             [class.expanded]="isRowExpanded(row)">
                    </mat-row>
                </ng-container>
            </mat-table>
        </section>
    </mat-card-content>

    <mat-card-footer *ngIf="!initialEmptyState" animated>
        <!-- Default Angular Material Paginator -->
        <mat-paginator *ngIf="paginatorStyle === 'default'"
                       [class.mobile-layout]="mobileMode$ | async"
                       [length]="resultsLength"
                       [pageSize]="effectiveDefaultPageSize"
                       [pageSizeOptions]="pageSizeOptions"
                       [attr.aria-label]="'Select page of loaded results'"
                       [disabled]="isLoadingInitialResults"
                       [selectConfig]="{ panelClass: 'v2-panel' }">
        </mat-paginator>

        <!-- V2 Custom Paginator (Figma design) -->
        <div *ngIf="paginatorStyle === 'v2'" class="v2-paginator" [class.mobile-layout]="mobileMode$ | async">
            <!-- Hidden mat-paginator to maintain pagination state -->
            <mat-paginator [length]="resultsLength"
                           [pageSize]="effectiveDefaultPageSize"
                           [pageSizeOptions]="pageSizeOptions"
                           [disabled]="isLoadingInitialResults"
                           style="display: none;">
            </mat-paginator>

            <div class="v2-paginator-container">
                <!-- Left side: Results info & items per page -->
                <div class="v2-paginator-info">
                    <span class="v2-paginator-results">
                        <span class="v2-paginator-label">Viewing </span>
                        <span class="v2-paginator-value">{{ v2PaginatorStart }}–{{ v2PaginatorEnd }} </span>
                        <span class="v2-paginator-label">of </span>
                        <span class="v2-paginator-value">{{ resultsLength }} </span>
                        <span class="v2-paginator-label">results</span>
                    </span>

                    <div class="v2-paginator-page-size">
                        <span class="v2-paginator-label">Items per page:</span>
                        <div class="v2-paginator-select" [matMenuTriggerFor]="pageSizeMenu">
                            <span class="v2-paginator-value">{{ paginator?.pageSize }}</span>
                            <mat-icon>expand_more</mat-icon>
                        </div>
                        <mat-menu #pageSizeMenu="matMenu" class="v2-panel v2-paginator-menu">
                            <button type="button" *ngFor="let size of pageSizeOptions; trackBy: trackByValue"
                                    mat-menu-item
                                    (click)="v2ChangePageSize(size)">
                                {{ size }}
                            </button>
                        </mat-menu>
                    </div>
                </div>

                <!-- Right side: Navigation buttons -->
                <div class="v2-paginator-nav">
                    <button type="button" class="v2-paginator-btn"
                            [disabled]="!v2HasPreviousPage || isLoadingInitialResults"
                            (click)="v2PreviousPage()">
                        Previous
                    </button>
                    <button type="button" class="v2-paginator-btn"
                            [disabled]="!v2HasNextPage || isLoadingInitialResults"
                            (click)="v2NextPage()">
                        Next
                    </button>
                </div>
            </div>
        </div>
    </mat-card-footer>
</mat-card>

<ng-content select="[appTableSuffix]"></ng-content>
